import { render, staticRenderFns } from "./CatalogTab.vue?vue&type=template&id=e3cd6d02&scoped=true"
import script from "./CatalogTab.vue?vue&type=script&lang=js"
export * from "./CatalogTab.vue?vue&type=script&lang=js"
import style0 from "./CatalogTab.vue?vue&type=style&index=0&id=e3cd6d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cd6d02",
  null
  
)

export default component.exports